<template>
  <div class="view pa24">
    <el-dialog :title="title" width="800px" :modal-append-to-body="false" :visible.sync="dialogVisible"
      :close-on-click-modal="false" :before-close="closeDialog">
      <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;">
        <el-table-column prop="className" align="center" label="产品名称" />
        <el-table-column prop="num"  align="center" label="数量" />
        <el-table-column prop="createTime" align="center" label="创建时间" />
      </el-table>
      <div class="pageBox">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageNum" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" class=""
          :total="total" :pager-count="5" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getPurchase, queryList, taskProcess } from '@/api/boomClass.js'
  import { baseUrl } from "@/utils/index"

  export default {
    name: "addPageClass",
    components: {},
    props: [],
    data() {
      let token = localStorage.getItem("token")
      return {
        fileList: [],
        uploadUrl: this.$store.state.uploadingUrl,
        ossUrl: this.$store.state.ossUrl,
        upParams: {
          token: token
        },
        provinces: [],
        classType: null,
        dialogVisible: false,
        title: '',
        tableData: {},
        rules: {},
        excleId: '',
        pageSize: 10,
        pageNum: 1,
        total: 0,

      };
    },
    onShow() { },
    // mounted() {
    //   this.resetForm()
    // },
    methods: {
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.resetForm(this.excleId);
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.resetForm(this.excleId);
      },
      async open(dat) {
        console.log(dat);
        // this.ruleForm={}
        this.excleId = dat.id
        this.dialogVisible = true
        this.title = '流程列表'
        this.resetForm(dat.id)
      },
      resetForm(id) {
        let param = {
          excelId: id,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        taskProcess(param).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
          console.log(this.tableData);
        })
      },
      closeDialog() {
        this.dialogVisible = false
      },
    }
  };
</script>
<style lang="scss" scoped>
  .component {
    margin-bottom: 10px;

    &.even {
      background-color: #f5f5f5;
    }

    &.odd {
      background-color: #fff;
    }
  }

  .accessory {
    margin-bottom: 10px;
    padding-left: 20px;

    &.even {
      background-color: #f5f5f5;
    }

    &.odd {
      background-color: #fff;
    }
  }

  .sub-accessory {
    margin-bottom: 10px;
    padding-left: 40px;

    &.even {
      background-color: #f5f5f5;
    }

    &.odd {
      background-color: #fff;
    }
  }
</style>